// extracted by mini-css-extract-plugin
export default {"root":"_2wWBt","icon":"_2zABk","tooltip":"_25uUu"};